export const isEven = () => Math.floor(Math.random() * 100) % 2 === 0